import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ed2199b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Hero" }
const _hoisted_2 = { class: "Hero__Inner section__inner" }
const _hoisted_3 = { class: "Hero__Subinner section__subinner grid" }
const _hoisted_4 = { class: "Hero__Left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "Hero__Time small-uppercase" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-clock" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_AppearObject = _resolveComponent("AppearObject")!
  const _component_LazyPicture = _resolveComponent("LazyPicture")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AppearObject, null, {
            default: _withCtx(() => [
              _createElementVNode("h1", null, [
                _createVNode(_component_LineByLine, {
                  innerHTML: _ctx.chapter.title
                }, null, 8, ["innerHTML"])
              ])
            ]),
            _: 1
          }),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('chapter.readingTime')) + " - " + _toDisplayString(_ctx.$t('chapter.minutes', {minutes: _ctx.chapter.readTime})), 1)
          ])
        ]),
        _createVNode(_component_AppearObject, { class: "Hero__Right" }, {
          default: _withCtx(() => [
            (_ctx.chapter.image?.url)
              ? (_openBlock(), _createBlock(_component_LazyPicture, {
                  key: 0,
                  image: _ctx.chapter.image,
                  alt: _ctx.chapter.title,
                  class: "picture picture--full",
                  lazy: false
                }, null, 8, ["image", "alt"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}